<div class="standing-order" [ngClass]="{'standing-order-active': sectionData.isActive}">
    <img src="{{sectionData.image}}" class="icon" />
    <div class="standing-title">
        <h3>{{ sectionData.title }}</h3>
        <span class="sub-title">{{ sectionData.subTitle }}</span>
    </div>
    <div class="input-wrapper">
        <input type="tel"
               class="sum"
               placeholder="{{ contents.calculator.inputPlaceHolder }}"
               appNumber
               [ngModel]="sectionData.sumValue | numberCurrency: 'ILS'"
               (input)="sumValueModelChanged($event)"
               maxlength="8"
               (focus)="onFocus()"
               (blur)="sumChanged()"
               (click)="$event.target.select()" />
        <span class="pen"></span>
    </div>
</div>